import { DropdownMenuItem } from '@jumpstone/ui-react';
import { useSignOutAction } from './use_sign_out_action';

/**
 * The sign-out row of both account menus — `AccountMenu` (admin `TopNav`) and
 * `EmployeeTopBar`'s avatar menu. Label and handler come from
 * `useSignOutAction`, the app's one sign-out action (see its docblock for
 * why there must be exactly one).
 */
export function SignOutMenuItem(): React.JSX.Element {
  const { label, sign_out } = useSignOutAction();
  return <DropdownMenuItem onSelect={sign_out}>{label}</DropdownMenuItem>;
}
